module.exports = __webpack_public_path__ + "img/komerce-logo.af14d5a2.svg";